import { render, staticRenderFns } from "./RepairShop.vue?vue&type=template&id=0bdf56a8&scoped=true"
import script from "./RepairShop.vue?vue&type=script&lang=js"
export * from "./RepairShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf56a8",
  null
  
)

export default component.exports